/**
 * Minimal toast notification store that replaces react-toasts.
 * API is compatible with the ToastStore from react-toasts v1.
 */
const subscribers = [];

const notify = (data) => {
  subscribers.forEach((fn) => fn(data));
};

const ToastStore = {
  success: (message, timer) => notify({ status: 'success', message, timer }),
  error:   (message, timer) => notify({ status: 'error',   message, timer }),
  info:    (message, timer) => notify({ status: 'info',    message, timer }),
  warning: (message, timer) => notify({ status: 'warning', message, timer }),
  watch:   (callback) => { subscribers.push(callback); return callback; },
  unwatch: (callback) => {
    const idx = subscribers.indexOf(callback);
    if (idx > -1) subscribers.splice(idx, 1);
  },
};

export { ToastStore };
export default ToastStore;
